import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "'Open Sans', sans-serif",
    },
  },
  palette: {
    primary: {
      main: "#ff0000",
      contrastText: "#fff",
    },
    secondary: {
      main: "#fff",
      contrastText: "#ff0000",
    },
  },
});

export default theme;
